var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoxSpecialist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.34766 0.716797C1.42383 0.539062 1.60156 0.462891 1.7793 0.488281L8 1.25L14.1953 0.488281C14.373 0.462891 14.5508 0.564453 14.627 0.716797L15.668 2.82422C15.8965 3.28125 15.668 3.83984 15.1855 3.9668L11.0215 5.16016C10.666 5.26172 10.2852 5.10938 10.1074 4.7793L8 1.25L5.86719 4.7793C5.68945 5.10938 5.30859 5.26172 4.95312 5.16016L0.814453 3.9668C0.306641 3.83984 0.078125 3.28125 0.306641 2.82422L1.34766 0.716797ZM8.02539 2.875L9.42188 5.21094C9.77734 5.8457 10.5391 6.125 11.25 5.92188L14.5 5.00781V9.24805C14.5 9.80664 14.1191 10.2891 13.5605 10.4414L8.38086 11.7363C8.12695 11.7871 7.84766 11.7871 7.59375 11.7363L2.41406 10.4414C1.88086 10.2891 1.5 9.80664 1.5 9.24805V5.00781L4.72461 5.92188C5.43555 6.125 6.19727 5.8457 6.57812 5.21094L7.94922 2.875H8.02539Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxSpecialist);
export default ForwardRef;